<template>
  <div
    class="bb-contact-visas-table-cell"
    :class="[column.isDynamic && 'bb-contact-visas-table-cell_dynamic']"
  >
    <div v-if="isEdit">
        <textarea
         class="bb-contact-visas-table-cell__input"
         :class="[
           column.isDynamic && 'bb-contact-visas-table-cell__input_dynamic'
         ]"
         :ref="`refs-input-text-input_${row.id}`"
         :autofocus="column.inputFocus"
         v-model="editableRow[column.prop]"
         @input="changeInput($event)"
        />
    </div>
    <div
      v-else
      :ref="`refs-input_${row.id}`"
      :id="`refs-input_${row.id}`"
    >{{ getVal }}</div>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'ContactCompanyVisasTableCell',
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    editableRow: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isEdit () {
      return this.row.id === this.editableRow.id
    },
    getVal () {
      return get(this.row, this.column.prop, '')
    },
    edit () {
      return this.editableRow[this.column.prop]
    }
  },
  methods: {
    cancelEditable () {
      this.$emit('cancelEditable')
    },
    changeInput (e) {
      this.setTextAreaHeight(e)
      this.$emit('changeInput', e, this.row, this.column)
    },
    setTextAreaHeight (e) {
      const { isDynamic = false } = this.column
      if (isDynamic) {
        const { target } = e
        const { scrollHeight = 0 } = target
        const { height } = this.row
        target.style.height = `${height}px`
        target.style.height = scrollHeight ? `${scrollHeight + 2}px` : `${scrollHeight}px`
        this.$set(this.row, 'height', scrollHeight)
      }
    },
    setRowHeight () {
      const { id } = this.row
      const element = this.$refs[`refs-input_${id}`]
      if (!element) return
      const position = element.getBoundingClientRect()
      if (!position) return
      const { height } = position
      this.$set(this.row, 'height', height)
    },
    setTextArea () {
      const { id } = this.row
      const element = this.$refs[`refs-input-text-input_${id}`]
      if (!element) return
      const { scrollHeight } = element
      element.style.height = `${scrollHeight + 2}px`
    }
  },
  watch: {
    edit () {
      this.$nextTick(() => {
        this.setTextArea()
      })
    }
  },
  mounted () {
    this.setRowHeight()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bb-contact-visas-table-cell {
    word-break: break-word;

    &_dynamic {
      white-space: pre-wrap;
    }

    &__input {
      height: 30px;
      display: inline-block;
      width: 100%;
      padding: 6px 10px;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 5px;
      transition: 0.3s;
      font-family: $global-font;
      font-size: 13px;
      resize: vertical;

      &_dynamic {
        resize: none;
        min-height: 30px;
        max-height: 250px;
      }

      &::-webkit-scrollbar {
        width: 0;
      }

      &::-webkit-scrollbar {
        width: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactCompanyVisasTableCell.vue